import React, { Fragment, useState } from "react";
import { DotsHorizontalIcon, CheckIcon } from "@heroicons/react/outline";
import MasterCard from "assets/BillingPayments/master.png";
import Visa from "assets/BillingPayments/visa.png";
import AmericanExpress from "assets/BillingPayments/american-express.png";
import unionPay from "assets/BillingPayments/unionpay1.png";
import JCB from "assets/BillingPayments/jcb.svg";
import Eftpos from "assets/BillingPayments/eftpos.png";
import {
  capitalizeFirstLetter,
  classNames,
  parseBooleanVal,
} from "Utils/utils";
import { Menu, Transition } from "@headlessui/react";
import api from "store/services/sp.services";
import Loader from "components/common/Loader/Loader";
import { authenticatedUser } from "store/actions/auth.actions";
import GetItemFromLocalstorage from "Utils/GetItemFromLocalstorage";
import { useDispatch } from "react-redux";
import { stripeDeleteCardLocally } from "store/actions/sp.actions";
import { toast } from "react-toastify";

const CardItem = (props) => {
  const { card, isDefaultCard } = props;
  const dispatch = useDispatch();

  const [makeDefaultLoader, setMakeDefaultLoader] = useState(false);
  const [dettachCardLoader, setDettachCardLoader] = useState(false);

  const mergePaymentSetting = (currentUser, incomingPaymentSetting) => {
    const previous = currentUser?.payment_setting || {};
    return {
      ...previous,
      ...(incomingPaymentSetting || {}),
    };
  };

  const getCardIcon = () => {
    switch (card?.card?.brand) {
      case "mastercard":
        return MasterCard;
      case "visa":
        return Visa;
      case "amex":
        return AmericanExpress;
      case "unionpay":
        return unionPay;
      case "jcb":
        return JCB;
      case "Eftpos Australia":
        return Eftpos;
      default:
        return "";
    }
  };

  const HandleMakeCardDefault = async (payment_method_id) => {
    try {
      setMakeDefaultLoader(true);
      const response = await api.stripeMakeDefaultCard({ payment_method_id });
      if (response?.payment_setting) {
        const user = await GetItemFromLocalstorage("user");
        if (user && response?.payment_setting?.default_payment_method_id) {
          await (user.is_default_card =
            response.payment_setting.default_payment_method_id);
        }
        if (
          user &&
          response?.payment_setting?.default_payment_method_id &&
          user?.payment_setting?.default_payment_method_id !==
            response?.payment_setting?.default_payment_method_id
        ) {
          await (user.is_default_card =
            response.payment_setting.default_payment_method_id);
          await (user.payment_setting = mergePaymentSetting(
            user,
            response.payment_setting
          ));
        }
        localStorage.setItem("user", JSON.stringify(user));
        handleClickOutside(payment_method_id);
        dispatch(authenticatedUser(user));
        toast.success("Card Mark Default Successfully!");
      }
      setMakeDefaultLoader(false);
    } catch (err) {
      setMakeDefaultLoader(false);
      console.log("err", err);
      toast.error(err?.message || "This card cannot be set as default.");
    }
  };

  const HandleDettachCard = async (payment_method_id) => {
    try {
      setDettachCardLoader(true);

      const response = await api.stripeDettachCard({ payment_method_id });

      if (response?.payment_setting) {
        const user = await GetItemFromLocalstorage("user");
        if (user && response?.payment_setting?.default_payment_method_id) {
          await (user.is_default_card =
            response.payment_setting.default_payment_method_id);
        }
        if (
          user &&
          response?.payment_setting?.default_payment_method_id &&
          user?.payment_setting?.default_payment_method_id !==
            response?.payment_setting?.default_payment_method_id
        ) {
          await (user.is_default_card =
            response.payment_setting.default_payment_method_id);
          await (user.payment_setting = mergePaymentSetting(
            user,
            response.payment_setting
          ));
        }
        localStorage.setItem("user", JSON.stringify(user));
        handleClickOutside(payment_method_id);
        dispatch(authenticatedUser(user));
        dispatch(stripeDeleteCardLocally(payment_method_id));
        toast.success("Card Detach Successfully!");
      }

      setDettachCardLoader(false);
    } catch (err) {
      setDettachCardLoader(false);
      console.log("err", err);
      toast.error(err?.message || "Something went wrong!");
    }
  };

  const handleClickOutside = (id) => {
    const component = document.getElementsByClassName(
      `buttonForCardItem-${id}`
    );
    if (component && component?.length > 0) {
      component[0].click();
    }
  };

  const brand = card?.card?.brand || "card";
  const cardName = card?.metadata?.card_name
    ? capitalizeFirstLetter(card.metadata.card_name)
    : `Card ending in ${card?.card?.last4 ?? ""}`;

  return (
    <div className='relative flex flex-col rounded-xl border border-slate-200/80 bg-gradient-to-br from-slate-50 to-white shadow-sm overflow-hidden min-w-0 hover:shadow-md transition-shadow'>
      {/* Card-style header: brand + actions */}
      <div className='flex items-center justify-between p-4 pb-2'>
        <div className='flex h-10 w-12 items-center justify-center rounded-lg bg-white/80 shadow-sm border border-slate-100'>
          {getCardIcon() ? (
            <img src={getCardIcon()} alt="" className='h-7 w-9 object-contain' />
          ) : (
            <span className='text-xs font-semibold text-slate-500 uppercase'>{brand}</span>
          )}
        </div>
        <div className='flex items-center gap-2'>
          {isDefaultCard && (
            <span className='rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-medium text-emerald-700 flex items-center gap-1'>
              <CheckIcon className='h-3.5 w-3.5' />
              Default
            </span>
          )}
          {!isDefaultCard && (
            <Menu as='div' className='relative'>
              <Menu.Button
                className={classNames(
                  `buttonForCardItem-${card.id}`,
                  "inline-flex cursor-pointer items-center justify-center rounded-lg p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
                )}
              >
                <DotsHorizontalIcon className='h-5 w-5' />
              </Menu.Button>
              <Transition
                as={Fragment}
                enter='transition ease-out duration-100'
                enterFrom='transform opacity-0 scale-95'
                enterTo='transform opacity-100 scale-100'
                leave='transition ease-in duration-75'
                leaveFrom='transform opacity-100 scale-100'
                leaveTo='transform opacity-0 scale-95'
              >
                <Menu.Items className='z-[100] origin-top-right absolute right-0 mt-1 w-48 rounded-lg shadow-lg bg-white border border-slate-200 divide-y divide-slate-100 focus:outline-none ring-1 ring-black/5'>
                  <div className='py-1'>
                    <Menu.Item>
                      {({ active }) => (
                        <span
                          role='button'
                          tabIndex={0}
                          onClick={() => HandleMakeCardDefault(card.id)}
                          className={classNames(
                            "flex items-center gap-x-2 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer",
                            active && "bg-slate-50"
                          )}
                        >
                          Make it Default
                          {makeDefaultLoader && <Loader isSmallView={true} cssClass='text-slate-600' />}
                        </span>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <span
                          role='button'
                          tabIndex={0}
                          onClick={() => HandleDettachCard(card.id)}
                          className={classNames(
                            "flex items-center gap-x-2 px-4 py-2.5 text-sm text-slate-700 hover:bg-red-50 hover:text-red-700 cursor-pointer",
                            active && "bg-red-50"
                          )}
                        >
                          Detach Card
                          {dettachCardLoader && <Loader isSmallView={true} cssClass='text-red-600' />}
                        </span>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          )}
        </div>
      </div>
      {/* Card details */}
      <div className='px-4 pb-4 pt-1 space-y-1'>
        <p className='text-sm font-medium text-slate-800 truncate' title={cardName}>
          {cardName}
        </p>
        <p className='text-sm text-slate-500 font-mono'>
          {capitalizeFirstLetter(brand)} •••• {card?.card?.last4 ?? "----"}
        </p>
        <p className='text-xs text-slate-400'>
          Expires {String(card?.card?.exp_month ?? "").padStart(2, "0")}/{card?.card?.exp_year ?? ""}
        </p>
      </div>
    </div>
  );
};

export default CardItem;
